import { useTheme } from '@emotion/react';
import {
  Backdrop,
  Box,
  CircularProgress,
  IconButton,
  InputBase,
  styled,
} from '@mui/material';
import { Search } from 'lucide-react';
import { useState } from 'react';

const StyledInputContainer = styled(Box)(({ backgroundColor, maxWidth }) => ({
  position: 'relative',
  width: '100%',
  maxWidth: maxWidth,
  alignItems: 'center',
  height: '40px',
  backgroundColor: backgroundColor,
  borderRadius: '10px',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  width: '100%',
  height: '40px',
  fontSize: 14,
  fontWeight: 500,
  paddingLeft: '16px',
  paddingRight: '8px',
  position: 'relative',
  zIndex: 1,
  background: 'none',
  '& input::placeholder': {
    fontWeight: 400,
    fontSize: 15,
    color: theme.palette.primary.grey400,
  },
}));

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  padding: '8px',
  color: '#888888',
}));

export default function FilterableSearchBar({
  onSearchChange,
  placeholder = '검색어를 입력하세요',
  maxWidth = '100%',
  backgroundColor = '#F6F6F6',
}) {
  const theme = useTheme();
  const [searchValue, setSearchValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = event => {
    const value = event.target.value;
    setSearchValue(value);
  };

  const handleSearchClick = async () => {
    if (onSearchChange && searchValue.trim()) {
      setIsLoading(true);
      try {
        // Simulate backend delay of 1.5 seconds
        await new Promise(resolve => setTimeout(resolve, 1000));
        await onSearchChange(searchValue);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleKeyPress = event => {
    if (event.key === 'Enter') {
      handleSearchClick();
    }
  };

  return (
    <>
      <StyledInputContainer backgroundColor={backgroundColor}>
        <StyledInputBase
          placeholder={placeholder}
          value={searchValue}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
          disabled={isLoading}
          endAdornment={
            <StyledIconButton onClick={handleSearchClick} disabled={isLoading}>
              <Search size={19} color={theme.palette.primary.grey400} />
            </StyledIconButton>
          }
        />
      </StyledInputContainer>

      <Backdrop
        sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" size={60} />
      </Backdrop>
    </>
  );
}
